
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import {
    DialogBase,
    DialogContainerBase,
    SelectAttribute,
    SelectAttributeValue,
} from '../../../core';

const DialogEditAttribute = ({
    attributes,
    open,
    onDismiss
}) => {

    const VALUE_EDIT = 1;
    const VALUE_CLOSE = 0;

    const [attribute, setAttribute] = React.useState();
    const [value, setValue] = React.useState();

    const getAttribute = (id) => {
        return (attributes || []).reduce((previous, current) => {
            return (current.id === id) ? current : previous;
        }, null);
    }

    const getIsValid = () => {
        return attribute && value;
    }

    const handleSetAttribute = (value) => {
        setAttribute(value);
    }

    const handleSetValue = (value) => {
        setValue(value);
    }

    const handleConfirm = () => {
        handleDismiss(VALUE_EDIT);
    }

    const handleDismiss = (resultValue) => {
        if (onDismiss) {
            let res = {button: resultValue};
            if (resultValue === VALUE_EDIT) {
                res.attribute = attribute;
                res.value = value;
            }
            onDismiss(res);
        }
    }

    return (
        <DialogBase
            buttons={[
                {primary: true, title: 'Přepsat', value: VALUE_EDIT, disabled: !getIsValid()},
                {primary: false, title: 'Zrušit', value: VALUE_CLOSE}
            ]}
            minWidth={500}
            open={open}
            onDismiss={handleDismiss}
            title="Hromadný přepis atributu"
        >
            <Stack>
                <SelectAttribute
                    attributes={attributes}
                    readOnly={false}
                    value={attribute}
                    onChange={handleSetAttribute}
                />
                <SelectAttributeValue
                    attribute={getAttribute(attribute)}
                    value={value}
                    onConfirm={handleConfirm}
                    onChange={handleSetValue}
                />
            </Stack>
        </DialogBase>
    );
}

class DialogEditAttributeContainer extends DialogContainerBase {
    static resolve = null;
    static instance = null;

    static create() {
        DialogEditAttributeContainer.instance = DialogContainerBase.create(
            DialogEditAttributeContainer.instance,
            DialogEditAttributeContainer
        );
        return DialogEditAttributeContainer.instance;
    }

    constructor(props) {
        super(props, {
            attributes: null
        });
    }

    getResolve() {
        return DialogEditAttributeContainer.resolve;
    }

    open(attributes) {
        return super.open({
            attributes
        });
    }

    renderContent() {
        let props = {
            attributes: this.state.attributes,
            ...this.getDialogProps()
        }
        return (
            <DialogEditAttribute
                {...props}
            />
        );
    }

    setResolve(res) {
        DialogEditAttributeContainer.resolve = res;
    }
}

export default DialogEditAttributeContainer.create;
